import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  withStyles,
} from "@material-ui/core";
import * as moment from "moment";
import Pagination from "@material-ui/lab/Pagination";
// import { Table, TableBody, TableCell, TableHead, TableRow, TablePagination, withStyles } from '@material-ui/core';
// import SearchIcon from '@material-ui/icons/Search';
// import { DebounceInput } from 'react-debounce-input';
import loader from "../../images/Spin-1s-107px.gif";

import {
  getEnrollForPartnerUser,
  getSettlementListForGroup,
  partnerUserDetail,
  getConsumerUser,
  getBusinessUserAffilate,
  getAffiliateUser,
  getAllGroupsByParentAffiliateUser,
  getAffiliateGroup,
} from "../../Actions/actions";

const CustomTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#fff",
    color: "#525659",
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

class GroupDetailContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      settlementDataAffiliateData: [],
      userid: localStorage.getItem("userId"),
      affiliateType: "",
      GetAffiliateUserData: "",
      rowsPerPage: 10,
      pageNumber: 1,
      searchKeyword: "",
      isLoader: false,
      sortBy: "",
      groupId: "",
      parentPartnerId: "",
      groupState: true,
      groupName: "",
      groupIdMain: "",
      AffiliateUserData: {},
    };
  }

  async componentDidMount() {
    const {
      match: { params },
    } = this.props;
    this.setState({
      isLoader: true,
    });
    const { userid } = this.state;
    const { getAffiliateUser } = this.props;
    getAffiliateUser(this.props.match.params.userId);
    // if (params.roleName === 'Business-User') {
    //     this.props.getBusinessUserAffilate(params.id);
    // } else {
    //     this.props.getConsumerUser(params.id);
    // }

    this.fetchData();
  }

  componentWillUnmount() {
    this.props.partnerUserDetail([]);
  }

  fetchData = () => {
    const {
      rowsPerPage,
      pageNumber,
      searchKeyword,
      userid,
      parentPartnerId,
      affiliateType,
    } = this.state;
    const {
      match: { params },
    } = this.props;
    this.setState({
      isLoader: true,
      groupId: params.id,
    });
    this.props.getSettlementListForGroup({
      pageNumber: pageNumber,
      pageSize: rowsPerPage,
      searchKeyword: searchKeyword,
      affiliateType: "Both",
      userId: userid,
      sortBy: "",
      partnerId: params.partnerId,
    });
  };

  componentWillReceiveProps(newProps) {
    const {
      rowsPerPage,
      pageNumber,
      searchKeyword,
      userid,
      parentPartnerId,
      affiliateType,
    } = this.state;
    const {
      match: { params },
    } = this.props;

    const {
      data: { receiveAllGroupsByParentAffiliateUser, GetAffiliateUser },
    } = this.props;
    this.setState({
      isLoader: true,
      groupId: params.id,
    });
    if (
      this.state.groupState == true &&
      newProps.data.GetAffiliateUser &&
      newProps.data.GetAffiliateUser.affiliateUserId
    ) {
      this.setState({
        groupState: false,
      });
      if (newProps.GetAffiliateUser != GetAffiliateUser) {
        this.props.getAllGroupsByParentAffiliateUser({
          pageNumber: "1",
          pageSize: rowsPerPage,
          searchKeyword: searchKeyword,
          affiliateType: affiliateType,
          parentPartnerId: newProps.data.GetAffiliateUser.affiliateUserId,
          displayMode: "partner",
        });
      }
    }
    if (
      newProps.data.receiveAllGroupsByParentAffiliateUser &&
      newProps.data.receiveAllGroupsByParentAffiliateUser.code == "200"
    ) {
      this.setState({
        isLoader: false,
        groupName:
          newProps.data.receiveAllGroupsByParentAffiliateUser.result.records[0]
            .name,
        groupIdMain:
          newProps.data.receiveAllGroupsByParentAffiliateUser.result.records[0]
            .id,
      });
    }
  }

  componentDidUpdate() {
    const { getEnrollmentUserDataCount } = this.props.data;
    const { settlementDataAffiliateData } = this.state;
    const {
      match: { params },
    } = this.props;
    let parentPartnerId = this.props.data.GetAffiliateUser.affiliateUserId;
    // let groupId = params.id;
    let groupIdMain = params.groupId;
    if (
      this.props.data.GetAffiliateUser &&
      this.props.data.GetAffiliateUser.affiliateUserId &&
      this.state.AffiliateUserData != this.props.data.GetAffiliateUser
    ) {
      this.setState({
        AffiliateUserData: this.props.data.GetAffiliateUser,
      });
      this.props.getAffiliateGroup({ parentPartnerId, groupId: groupIdMain });
    }

    if (getEnrollmentUserDataCount !== settlementDataAffiliateData) {
      this.setState({
        settlementDataAffiliateData: getEnrollmentUserDataCount,
        isLoader: false,
      });
    }
  }

  handleChangePage = (event, newPage) => {
    this.setState(
      {
        pageNumber: parseInt(newPage, 10),
      },
      () => {
        this.fetchData();
      }
    );
  };

  UNSAFE_componentWillReceiveProps(newProps) {
    if (
      newProps.data.receiveGetSettlementListForGroup &&
      newProps.data.receiveGetSettlementListForGroup.code == "400" &&
      this.state.isLoader == true
    ) {
      this.setState({
        isLoader: false,
      });
    }
    if (
      newProps.data.receiveGetSettlementListForGroup &&
      newProps.data.receiveGetSettlementListForGroup.code == "200" &&
      this.state.isLoader == true
    ) {
      this.setState({
        isLoader: false,
      });
    }
    if (
      newProps.data.receiveGetAffiliateGroup &&
      newProps.data.receiveGetAffiliateGroup.code == "400" &&
      this.state.isLoader == true
    ) {
      this.setState({
        isLoader: false,
      });
    }
    if (
      newProps.data.receiveGetAffiliateGroup &&
      newProps.data.receiveGetAffiliateGroup.code == "200" &&
      this.state.isLoader == true
    ) {
      this.setState({
        isLoader: false,
      });
    }
  }

  handleChangeRowsPerPage = (event) => {
    this.setState(
      {
        rowsPerPage: parseInt(event.target.value, 10),
      },
      () => {
        this.fetchData();
      }
    );
  };

  render() {
    const userObject = JSON.parse(localStorage.getItem("userObject"));
    console.log("user2",userObject.userDto.firstName);
    const { rowsPerPage, pageNumber, searchKeyword, isLoader } = this.state;
    const {
      match: { params },
      data: {
        getEnrollmentUserDataCount,
        BusinessUserProfileDataAffilate,
        ConsumerUserData,
        receiveGetSettlementListForGroup,
        receiveGetAffiliateGroup,
      },
    } = this.props;
    console.log("matchdata", this.props.match.params, {
      receiveGetAffiliateGroup,
    });
    let spans = null;
    if (
      this.props.data.GetAffiliateUser.parentPartnerName != userObject.userDto.firstName+ " " + userObject.userDto.lastName
    ) {
      spans = <span>></span>;
    }
    let spansone = null;
    if (
      this.props.data.GetAffiliateUser.parentPartnerName != userObject.userDto.firstName+ " " + userObject.userDto.lastName
    ) {
      spansone = (
        <span>
          <Link
            to={`/groupDetail/${params.groupId}/${this.props.data.GetAffiliateUser.parentPartnerId}`}
          >
            {this.props.data.GetAffiliateUser.parentPartnerName}
          </Link>
        </span>
      );
    }
    return (
      <div className="">
        {isLoader === true ? (
          <div className="loader">
            <img src={loader} alt="" />
          </div>
        ) : (
          ""
        )}

        <div className="tab-container-inner">
          <div className="breadcrumbs">
            <span>
              <Link to="/groupsAffiliate">List</Link>
            </span>

            <span>></span>
            {/* <span>{this.props.data.getAffiliateGroupReducer.result && this.props.data.getAffiliateGroupReducer.result.groupName}</span> */}
            <span>
              <Link to={`/groupsAffiliate/${params.groupId}`}>
                {this.props.data.getAffiliateGroupReducer.result &&
                  this.props.data.getAffiliateGroupReducer.result.groupName}
              </Link>
            </span>
            {spans}
            {spansone}

            <span>></span>
            <span>
              {/* <Link to={`/groupDetail/${params.groupId}/${params.partnerId}`} > */}
              {this.props.data.GetAffiliateUser.companyName}
              {/* </Link> */}
            </span>
          </div>
          <h3 className="h3-head-main ">Details</h3>
          <div className="card card-p-g">
            <div className="card-header p-5">
              <h3 className="m-0 h3-head">Information</h3>
            </div>
            <div className="card-body p-5">
              <div className="p-user-detail">
                <div className="p-user-detail-col">
                  <div class="p-user-label">BUSINESS NAME</div>
                  <div class="p-user-details">
                    {this.props.data.GetAffiliateUser.companyName}
                  </div>
                </div>
                <div className="p-user-detail-col">
                  <div class="p-user-label">NAME</div>
                  <div class="p-user-details">
                    {this.props.data.GetAffiliateUser.fullName}
                  </div>
                </div>
                <div className="p-user-detail-col">
                  <div class="p-user-label">EMAIL ID</div>
                  <div class="p-user-details" style={{ color: "#0692ff" }}>
                    {this.props.data.GetAffiliateUser.email}
                  </div>
                </div>
                <div className="p-user-detail-col">
                  <div class="p-user-label">NUMBER OF SETTLEMENTS</div>
                  <div class="p-user-details">
                    {receiveGetSettlementListForGroup.result &&
                      receiveGetSettlementListForGroup.result.totalCount}
                  </div>
                </div>
                <div className="p-user-detail-col">
                  <div class="p-user-label">POSITION</div>
                  <div class="p-user-details">
                    {this.props.data.GetAffiliateUser.companyPostion}
                  </div>
                </div>
                <div className="p-user-detail-col">
                  <div class="p-user-label ">ACTIVE</div>
                  <div class="p-user-details">
                    {this.props.data.GetAffiliateUser.active === 1
                      ? "True"
                      : "False"}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* <div className="card card-p-g">
                         <div className="card-header p-5" >
                             <h3 className="m-0 h3-head">
                             Enrollments
                             </h3>
                         </div> 
                         <div className="card-body p-5">
                         <div className="p-table-outer p-table-user-detail">
                        {getEnrollmentUserDataCount && getEnrollmentUserDataCount.code === 200 ? (
                            <Table >
                                <TableHead>
                                    <TableRow>
                                        <CustomTableCell>Name</CustomTableCell>
                                        <CustomTableCell >Category</CustomTableCell>
                                        <CustomTableCell >Filing Deadline</CustomTableCell>
                                        <CustomTableCell >Total Enrollments</CustomTableCell>
                                        <CustomTableCell >Action</CustomTableCell>

                                    </TableRow>
                                </TableHead>

                                {console.log('getEnrollmentUserDataCount.result', getEnrollmentUserDataCount.result)}
                                <TableBody className="p-table-body">{
                                    getEnrollmentUserDataCount.result ?
                                        getEnrollmentUserDataCount.result.records.map((item) => (
                                            <TableRow key={item.userId} >
                                                <CustomTableCell >{item.shortName}</CustomTableCell>
                                                <CustomTableCell >
                                                    {item.categoryName}
                                                </CustomTableCell>
                                                <CustomTableCell >{item.settlementImportantDateDto !== undefined ? moment(item.settlementImportantDateDto.claimPeriodEnd !== undefined ? item.settlementImportantDateDto.claimPeriodEnd : '').format('MM-DD-YYYY') !== 'Invalid date' ? moment(item.settlementImportantDateDto.claimPeriodEnd !== undefined ? item.settlementImportantDateDto.claimPeriodEnd : '').format('MM/DD/YYYY') : 'TBA' : ''}</CustomTableCell>
                                                <CustomTableCell >{item.enrollmentStatus}</CustomTableCell>

                                                <CustomTableCell > <Link
                                                    // to="/userDetail"
                                                    to={`/settlementAffiliate/${item.id}`}
                                                >
                                                    View
                </Link></CustomTableCell>
                                            </TableRow>
                                        ))
                                        : (<TableRow  >
                                            <CustomTableCell >Record Not found</CustomTableCell></TableRow>)
                                }</TableBody>




                            </Table>) : getEnrollmentUserDataCount.code === 404 ? (

                                <Table >
                                    <TableHead>
                                        <TableRow>
                                        <CustomTableCell>Name</CustomTableCell>
                                        <CustomTableCell >Category</CustomTableCell>
                                        <CustomTableCell >Filing Deadline</CustomTableCell>
                                        <CustomTableCell >Total Enrollments</CustomTableCell>
                                        <CustomTableCell >Action</CustomTableCell>

                                        </TableRow>
                                    </TableHead>
                                    <TableRow  >
                                        <CustomTableCell >Record Not found</CustomTableCell></TableRow>
                                </Table>
                            ) : ""}
                    </div>
                    <Pagination 
                        count={getEnrollmentUserDataCount.result && getEnrollmentUserDataCount.result.totalCount > getEnrollmentUserDataCount.result.pageSize ? Math.ceil(getEnrollmentUserDataCount.result.totalCount/getEnrollmentUserDataCount.result.pageSize) : 1} variant="outlined" shape="rounded"
                        // count={settlementRefeDataAffiliateData.result && Math.round(settlementRefeDataAffiliateData.result.totalCount/settlementRefeDataAffiliateData.result.pageSize)} variant="outlined" shape="rounded"
                        onChange={this.handleChangePage}
                        page={pageNumber}
                        className="custom-pagination"
                    />
                         </div>
                         </div>
 */}
          <div className="card-table-outer">
            <div className="table-filter p-user-detail-filter">
              <h3 className="table-filter-tittle">
                Settlements
                {/* <span> {getEnrollmentUserDataCount && getEnrollmentUserDataCount.result && (<span>({getEnrollmentUserDataCount.result.totalCount})</span>)} </span> */}
              </h3>
              <div className="filter-form">
                {/* <div className="input-search-outer">
                                <DebounceInput
                                    placeholder="Search"
                                    type="search"
                                    // className={className}
                                    debounceTimeout={500}
                                    onChange={(evet) => {

                                        this.setState({
                                            searchKeyword: evet.target.value
                                        }, () => {
                                            this.fetchData()
                                        })
                                    }}
                                    forceNotifyByEnter={false}
                                    value={searchKeyword}
                                />

                                <SearchIcon className="p-serch-icon " />
                                <SearchIcon className="p-serch-icon " />
                            </div> */}
              </div>
            </div>
            <div className="p-table-outer p-table-user-detail">
              {receiveGetSettlementListForGroup &&
              receiveGetSettlementListForGroup.code === 200 ? (
                <Table>
                  <TableHead>
                    <TableRow>
                      <CustomTableCell>Name</CustomTableCell>
                      <CustomTableCell>Category</CustomTableCell>
                      <CustomTableCell>Filing Deadline</CustomTableCell>
                      <CustomTableCell>Total Enrollments</CustomTableCell>
                      <CustomTableCell>Action</CustomTableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody className="p-table-body">
                    {receiveGetSettlementListForGroup.result ? (
                      receiveGetSettlementListForGroup.result.records.map(
                        (item) => (
                          <TableRow key={item.userId}>
                            <CustomTableCell>{item.shortName}</CustomTableCell>
                            <CustomTableCell>
                              {item.categoryName}
                            </CustomTableCell>
                            <CustomTableCell>
                              {item.settlementImportantDateDto !== undefined
                                ? moment(
                                    item.settlementImportantDateDto
                                      .claimPeriodEnd !== undefined
                                      ? item.settlementImportantDateDto
                                          .claimPeriodEnd
                                      : ""
                                  ).format("MM-DD-YYYY") !== "Invalid date"
                                  ? moment(
                                      item.settlementImportantDateDto
                                        .claimPeriodEnd !== undefined
                                        ? item.settlementImportantDateDto
                                            .claimPeriodEnd
                                        : ""
                                    ).format("MM/DD/YYYY")
                                  : "TBA"
                                : ""}
                            </CustomTableCell>
                            <CustomTableCell>
                              {item.enrolledUsers}
                            </CustomTableCell>

                            <CustomTableCell>
                              {" "}
                              <Link
                                // to="/userDetail"
                                to={`/settlementAffiliate/${item.id}/${this.props.match.params.groupId}/${this.props.match.params.partnerId}`}
                              >
                                View
                              </Link>
                            </CustomTableCell>
                          </TableRow>
                        )
                      )
                    ) : (
                      <TableRow>
                        <CustomTableCell>Record Not found</CustomTableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              ) : receiveGetSettlementListForGroup.code === 404 ? (
                <Table>
                  <TableHead>
                    <TableRow>
                      <CustomTableCell>Name</CustomTableCell>
                      <CustomTableCell>Category</CustomTableCell>
                      <CustomTableCell>Filing Deadline</CustomTableCell>
                      <CustomTableCell>Total Enrollments</CustomTableCell>
                      <CustomTableCell>Action</CustomTableCell>
                    </TableRow>
                  </TableHead>
                  <TableRow>
                    <CustomTableCell>Record Not found</CustomTableCell>
                  </TableRow>
                </Table>
              ) : (
                ""
              )}
            </div>
            <Pagination
              count={
                receiveGetSettlementListForGroup.result &&
                receiveGetSettlementListForGroup.result.totalCount >
                  receiveGetSettlementListForGroup.result.pageSize
                  ? Math.ceil(
                      receiveGetSettlementListForGroup.result.totalCount /
                        receiveGetSettlementListForGroup.result.pageSize
                    )
                  : 1
              }
              variant="outlined"
              shape="rounded"
              // count={settlementRefeDataAffiliateData.result && Math.round(settlementRefeDataAffiliateData.result.totalCount/settlementRefeDataAffiliateData.result.pageSize)} variant="outlined" shape="rounded"
              onChange={this.handleChangePage}
              page={pageNumber}
              className="custom-pagination"
            />
          </div>
          {/* <TablePagination
                        component="div"
                        count={getEnrollmentUserDataCount && getEnrollmentUserDataCount.result && getEnrollmentUserDataCount.result.totalCount ? getEnrollmentUserDataCount.result.totalCount : 0}
                        rowsPerPage={rowsPerPage}
                        page={pageNumber}
                        backIconButtonProps={{
                            'aria-label': 'Previous Page',
                        }}
                        nextIconButtonProps={{
                            'aria-label': 'Next Page',
                        }}
                        onChangePage={this.handleChangePage}
                        onChangeRowsPerPage={this.handleChangeRowsPerPage}
                    /> */}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({ data: state.data });

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getEnrollForPartnerUser,
      getSettlementListForGroup,
      getConsumerUser,
      partnerUserDetail,
      getBusinessUserAffilate,
      getAffiliateUser,
      getAllGroupsByParentAffiliateUser,
      getAffiliateGroup,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GroupDetailContainer);
